import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const auth = useAuth();
  const { loading } = auth;
  const ctxAuthed = auth && typeof auth.isAuthenticated === 'boolean' ? auth.isAuthenticated : undefined;
  // Fallback only to persisted user/admin tokens; do NOT trust loginAsToken for auth gating
  const tokenAuthed = !!(localStorage.getItem('token') || localStorage.getItem('admin_token'));
  const isAuthed = typeof ctxAuthed === 'boolean' ? ctxAuthed : tokenAuthed;

  if (loading) {
    return null; // Avoid redirects during verification
  }

  if (!isAuthed) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;